/*                                     */
/**
 *
 *
 *
 *
 *
 *
 *
 */
import { o_util } from "@gr-common/head/namespaces";
import { asExport } from "@gr-exports/head/core";
import { noop } from "@gr-common/head/function";
/**
 *
 *
 */
export const toggle = asExport(o_util, "toggle", noop);
/**
 *
 *
 *
 *
 *
 */
export const get = asExport(toggle, "get", noop);
/**
 *
 *
 *
 *
 */
export const getToggle = asExport(toggle, "getToggle", noop);
